import React from "react";
import SideBySideLayout from "@components/SideBySideLayout";
import BGDesktop from "./img/bg-desktop.jpg";
import BGMobile from "./img/bg-mobile.jpg";
import LockIcon from "./img/lock-icon.svg?react";
import SectionHeader from "@components/SectionHeader";
import "./style.scss";

export default function AgeGateFailed() {
  return (
    <SideBySideLayout
      position="top"
      bgImageDesktop={BGDesktop}
      bgImageMobile={BGMobile}
    >
      <div className="age-gate-failed-content">
        <SectionHeader>
          <strong>Altersüberprüfung</strong>
        </SectionHeader>
        <div className="inner-content">
          <div className="copy">
            <h1>Es tut uns Leid. Du kannst nicht beitreten.</h1>
            <p>
              Diese Webseite ist nur für Erwachsene Nikotinkonsumenten
              zugänglich.
            </p>
          </div>
          <LockIcon />
        </div>
      </div>
    </SideBySideLayout>
  );
}
